<div class="flex flex-col gap-4 mx-2">
  <div>
    <h1>Deine Bewerbung</h1>
    <taures-message header="Wir freuen uns auf deine Bewerbung" severity="info" class="flex mt-4">
      <p>
        Bitte beachte den <strong>Anmeldeschluss</strong> am <strong>{{ this.anmeldeschluss | date: 'dd.MM.yyyy, HH:mm' }} Uhr</strong>.
        <br />
        <br />
        Da eine Zwischenspeicherung der Daten aus datenschutzrechtlichen Gründen nicht möglich ist, empfehlen wir dir, alle Abschlusszeugnisse im
        PDF-Format bereitzuhalten und den Text für deine Motivation ggf. vorher vorzubereiten.
      </p>
    </taures-message>
  </div>
  <form [formGroup]="form" (submit)="onSubmit()" class="flex flex-col gap-4">
    <p-card header="Persönliche Daten">
      <div class="flex flex-col gap-4" [formGroup]="form.controls.interessent">
        <!-- ========= GESCHLECHT ========= -->
        <div class="flex flex-col gap-2">
          <div class="flex flex-col md:flex-row gap-2">
            @for (category of geschlechtCategories; track category) {
              <div>
                <p-radioButton [inputId]="category.key" [value]="category.key" [formControl]="form.controls.interessent.controls.geschlecht" />
                <label [for]="category.key" class="ml-2">{{ category.label }}</label>
              </div>
            }
          </div>
          @if (geschlechtNotSelected()) {
            <small class="form-hint-text-error">Bitte wähle ein Geschlecht aus.</small>
          }
        </div>

        <!-- ========= VORNAME, NACHNAME ========= -->
        <div class="flex flex-col w-full">
          <div class="flex flex-col md:flex-row w-full gap-y-8 md:gap-x-4">
            <div class="w-full md:w-1/2">
              <p-floatlabel class="w-full" variant="on">
                <input id="vorname" class="w-full" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.vorname" />
                <label for="vorname">Vollständiger Vorname*</label>
              </p-floatlabel>
              <app-field-error [control]="form.controls.interessent.controls.vorname" />
            </div>
            <div class="w-full md:w-1/2">
              <p-floatlabel class="w-full" variant="on">
                <input id="nachname" class="w-full" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.nachname" />
                <label for="nachname">Vollständiger Nachname*</label>
              </p-floatlabel>
              <app-field-error [control]="form.controls.interessent.controls.nachname" />
            </div>
          </div>
          <small class="form-hint-text">
            Um mögliche Dubletten zu vermeiden, beachte bitte die korrekte und vollständige Eingabe deiner Daten, ggf. unter Berücksichtigung eines
            Vornamens, analog zu deinem Personalausweis.
          </small>
        </div>

        <!-- ========= RUFNAME, GEBURTSNAME ========= -->
        <div class="flex flex-col w-full">
          <div class="flex flex-col md:flex-row w-full gap-y-8 md:gap-x-4">
            <div class="w-full md:w-1/2">
              <p-floatlabel class="w-full" variant="on">
                <input class="w-full" id="rufname" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.rufname" />
                <label for="rufname">Rufname</label>
              </p-floatlabel>
              <app-field-error [control]="form.controls.interessent.controls.rufname" />
            </div>
            <div class="w-full md:w-1/2">
              <p-floatlabel class="w-full" variant="on">
                <input
                  class="w-full"
                  id="geburtsname"
                  type="text"
                  pInputText
                  appTrTrim
                  [formControl]="form.controls.interessent.controls.geburtsname"
                />
                <label for="geburtsname">Geburtsname</label>
              </p-floatlabel>
              <app-field-error [control]="form.controls.interessent.controls.geburtsname" />
            </div>
          </div>
          <small class="form-hint-text w-full md:w-1/2"
            >Diese Angabe dient als zusätzliche Info hinsichtlich der Erstellung von Namensschildern.</small
          >
        </div>

        <!-- ========= NATIONALITAET, GEBURTSDATUM ========= -->
        <div class="flex flex-col md:flex-row gap-y-8 gap-x-4">
          <div class="md:w-2/3">
            <p-floatlabel class="w-full" variant="on">
              <p-select
                fluid="true"
                inputId="nationalitaet"
                [options]="sortedCountries"
                [optionLabel]="'name'"
                [optionValue]="'code'"
                [formControl]="form.controls.interessent.controls.nationalitaet"
              />
              <label for="nationalitaet">Nationalität*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.nationalitaet" />
          </div>
          <div class="md:w-1/3">
            <p-floatlabel class="w-full" variant="on">
              <p-datePicker
                inputId="geburtsdatum"
                fluid="true"
                [formControl]="form.controls.interessent.controls.geburtsdatum"
                [showIcon]="true"
                iconDisplay="input"
                dateFormat="dd.mm.yy"
              />
              <label for="geburtsdatum">Geburtsdatum*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.geburtsdatum" />
          </div>
        </div>
      </div>
    </p-card>

    <!-- ========= BILD ========= -->
    <app-foto [control]="form.controls.bewerbungsunterlagen.controls.bild"></app-foto>

    <p-card header="Kontaktdaten">
      <div class="flex flex-col gap-4 mt-2" [formGroup]="form.controls.interessent">
        <!-- ========= STRASSE, HAUSNUMMER ========= -->
        <div class="flex flex-col md:flex-row gap-y-8 gap-x-4">
          <div class="md:w-2/3">
            <p-floatlabel class="w-full" variant="on">
              <input fluid="true" id="strasse" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.strasse" />
              <label for="strasse">Straße*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.strasse" />
          </div>
          <div class="md:w-1/3">
            <p-floatlabel class="w-full" variant="on">
              <input fluid="true" id="hausnummer" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.hausnummer" />
              <label for="hausnummer">Hausnummer*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.hausnummer" />
          </div>
        </div>

        <!-- ========= PLZ, ORT ========= -->
        <div class="flex w-full gap-x-4">
          <div class="w-1/3">
            <p-floatlabel class="w-full" variant="on">
              <input fluid="true" id="plz" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.plz" />
              <label for="plz">PLZ*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.plz" />
          </div>
          <div class="w-2/3">
            <p-floatlabel class="w-full" variant="on">
              <input fluid="true" id="stadt" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.stadt" />
              <label for="stadt">Ort*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.stadt" />
          </div>
        </div>

        <!-- ========= TELEFON PRIVAT, TELEFON MOBIL ========= -->
        <div class="flex flex-col md:flex-row gap-y-8 gap-x-4">
          <div class="md:w-1/2">
            <p-floatlabel class="w-full" variant="on">
              <input fluid="true" id="festnetz" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.telefonPrivat" />
              <label for="festnetz">Telefon (Festnetz)</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.telefonPrivat" />
          </div>
          <div class="md:w-1/2">
            <p-floatlabel class="w-full" variant="on">
              <input fluid="true" id="mobil" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.telefonMobil" />
              <label for="mobil">Telefon (mobil)*</label>
            </p-floatlabel>
            <app-field-error [control]="form.controls.interessent.controls.telefonMobil" />
          </div>
        </div>

        <!-- ========= E-MAIL ========= -->
        <div class="w-full">
          <p-floatlabel class="w-full" variant="on">
            <input class="w-full" id="email" type="text" pInputText appTrTrim [formControl]="form.controls.interessent.controls.email" />
            <label for="email">E-Mail*</label>
          </p-floatlabel>
          <app-field-error [control]="form.controls.interessent.controls.email" />
        </div>
      </div>
    </p-card>

    <taures-message header="Hinweis" severity="info">
      <p>
        Bitte erfasse hier möglichst alle Stationen im Rahmen deines Lebenslaufes. Nur so ist es uns möglich, ein umfassendes Bild von dir zu
        erhalten. Bewerbungen die unvollständig eingereicht werden, können nicht bearbeitet werden. Deinen Lebenslauf benötigen wir
        <strong>nicht</strong> im PDF-Format. Etwaige Auslandaufenthalte kannst du unter „Werdegang“ eintragen.
      </p>
    </taures-message>

    <!-- ========= WERDEGANG ========= -->
    <ng-container [formGroup]="form.controls.bewerbungsunterlagen">
      <p-card header="Werdegang">
        <div class="flex flex-col w-full gap-2" formArrayName="berufserfahrung">
          @for (position of this.form.controls.bewerbungsunterlagen.controls.berufserfahrung.controls; track position; let index = $index) {
            <app-werdegang [berufserfahrungForm]="position" (remove)="removeBerufserfahrung(index)"></app-werdegang>
          }
        </div>
        <ng-template pTemplate="footer">
          <p-button outlined severity="primary" (click)="addBerufserfahrung()" label="Position hinzufügen">
            <span class="material-symbols-outlined">add</span>
          </p-button>
        </ng-template>
      </p-card>

      <!-- ========= AUSBILDUNG & SCHULE ========= -->
      <app-bildung [ausbildungen]="form.controls.bewerbungsunterlagen.controls.ausbildung" />

      <!-- ========= EHRENAMT ========= -->
      <p-card header="Ehrenamt">
        <div class="flex flex-col gap-2" formArrayName="ehrenamt">
          @for (amt of this.form.controls.bewerbungsunterlagen.controls.ehrenamt.controls; track amt; let index = $index) {
            <app-ehrenamt [ehrenamtForm]="amt" (remove)="removeEhrenamt(index)"></app-ehrenamt>
          }
        </div>
        <ng-template pTemplate="footer">
          <p-button outlined severity="primary" (click)="addEhrenamt()" label="Ehrenamt hinzufügen">
            <span class="material-symbols-outlined">add</span>
          </p-button>
        </ng-template>
      </p-card>

      <app-sonstiges [sonstiges]="form.controls.bewerbungsunterlagen.controls.sonstiges"></app-sonstiges>

      <app-motivation [motivation]="form.controls.bewerbungsunterlagen.controls.motivation"></app-motivation>
    </ng-container>

    <app-dokumente [documents]="form.controls.dokumente"></app-dokumente>

    <taures-message header="Hinweis" severity="warn"> Die Unterlagen können nach dem Absenden nicht mehr bearbeitet werden. </taures-message>
    @if (this.stateService.getHasError()) {
      <taures-message header="Fehler" severity="error">Fehler beim Laden von Anwendungsdaten.</taures-message>
    }
    <div class="flex justify-end">
      <p-button type="submit" label="Bewerbung absenden" [loading]="this.stateService.getIsLoading()">
        <span class="material-symbols-outlined">send</span>
      </p-button>
    </div>
  </form>
</div>
